import React from 'react';

export default function SiblingIcon() {
  return (
    <svg width="130" height="120" viewBox="0 0 165 150" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d)">
        <circle opacity="0.5" cx="88.4643" cy="57.2857" r="84.4143" fill="white" />
        <circle opacity="0.5" cx="87.9819" cy="57.7681" r="68.4962" fill="white" />
        <circle opacity="0.5" cx="90.3937" cy="57.2857" r="54.5075" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M75.2297 33.8886C67.1688 36.0635 70.3317 48.6062 78.5905 46.3099C86.4638 44.1139 83.4937 31.6609 75.2297 33.8886Z"
          fill="#7752A0"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M97.4009 34.4587C89.0743 37.4466 93.6336 49.3611 101.413 46.6372C104.216 45.6553 106.65 42.3982 105.368 38.5129C104.487 35.8471 101.298 33.0598 97.4009 34.4587Z"
          fill="#7752A0"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M107.879 75.0536L101.997 75.1169C102.09 76.273 102.544 78.2103 102.841 79.472C103.169 80.8815 104.091 81.9214 105.675 81.9953C109.437 82.1642 108.546 77.7247 107.879 75.0536Z"
          fill="#7752A0"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M94.139 75.1802C93.9567 77.7616 93.545 81.2879 96.5932 80.9976C98.7765 80.7864 99.2038 77.4871 99.1048 75.043L94.139 75.1802Z"
          fill="#7752A0"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M65.4962 37.3991C66.1892 38.2437 67.8202 38.3599 68.8831 38.4232C69.1332 37.4888 69.3886 36.8079 69.8054 36.0424C70.2431 35.2453 70.8944 34.7016 71.056 33.9995C70.2275 33.4663 67.5649 31.6451 66.6843 32.1888C65.986 32.6217 65.1315 36.5334 65.4962 37.3991Z"
          fill="#7752A0"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M78.3665 79.6937C78.9084 80.38 79.1897 80.2902 80.3465 80.2744C82.4985 80.2374 82.7069 79.6198 82.2953 75.0588L78.1268 75.0694C77.9757 76.2835 77.6995 78.8227 78.3665 79.6937Z"
          fill="#7752A0"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M72.6348 75.0588C72.5358 76.0038 72.3534 79.055 72.8484 79.7359C73.5519 80.7073 75.954 80.3008 76.7303 79.662C77.0273 78.5218 76.9648 76.2677 76.8293 75.0588H72.6348Z"
          fill="#7752A0"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M82.3213 33.7778C82.7486 34.8019 84.093 35.2928 84.7703 38.2332C88.5845 38.0906 87.5268 36.697 86.9119 33.7989C86.6618 32.6217 86.4377 31.5765 84.9423 32.173C84.5463 32.3313 82.6861 33.4769 82.3213 33.7778Z"
          fill="#7752A0"
        />
        <path
          d="M65.1836 60.9958C64.8084 62.2997 64.8918 63.44 66.554 63.4083L66.851 63.4664L67.0751 63.1971C67.2157 63.0335 67.2678 62.9754 67.3981 62.8223L68.831 60.6369C69.5657 59.7658 71.1602 56.7569 71.8949 56.4085L71.0351 60.5893C70.7642 62.1889 69.1801 65.5462 70.2744 67.0032C70.5297 67.0824 70.363 66.8818 70.858 67.2672C71.4728 67.964 72.2596 66.9979 72.5931 67.8742L72.6765 68.4971L72.6296 73.3273L76.8971 73.3221L76.8971 68.8719V67.6261L77.5171 67.5786L78.0591 67.6261L78.0486 73.3326L82.2692 73.264L82.3318 67.5047L83.0508 67.4414C83.9835 67.5522 84.0565 67.5417 84.6036 66.8818L84.9371 66.4542L84.911 66.3381L84.6296 64.9657L84.5768 64.5C84.4778 64.0998 84.5768 64.6667 84.4123 63.8333C84.3381 63.4576 84.1406 62.3062 84.0833 62L83.7542 60.3333C83.4535 59.0683 82.8714 57.1583 82.7672 55.8333C83.6165 56.2768 84.5932 58.008 85.2132 58.7365L87.538 61.7877C87.538 61.7877 87.5201 63.7908 88.3605 64.5C88.3605 64.5 89.3388 64.985 90.0056 64.9657C90.6108 64.9482 91.4862 64.5 91.4862 64.5C92.3088 63.8333 92.3088 63 92.6378 61.7877C92.7425 61.402 93.3353 60.4065 93.4604 60L94.707 57.7968L94.337 68.7928L94.1964 73.3274L99.5216 73.2746C99.6727 71.6487 100.256 69.8802 100.074 68.2913L100.564 68.3652C100.741 69.648 101.163 72.356 101.7 73.3221L107.614 73.3326L107.072 69.8802L106.889 68.5605L106.629 67.5047L106.394 66.1269L106.198 65.2929C106.107 64.6647 106.072 64.501 105.915 63.6406L105.738 62.6956L105.571 61.1542L105.545 61.2334C105.477 60.716 105.191 59.9544 105.066 59.0585L104.977 57.612C105.264 57.8285 105.128 57.6437 105.363 57.9499L106.082 59.2379C106.556 60.1565 106.198 59.5864 106.629 60.3782C106.681 60.4204 107.051 60.9641 107.072 61.0592C107.093 61.1542 107.41 61.6979 107.41 61.6979C107.697 62.1572 107.671 61.9619 107.932 62.5584L108.608 63.9256L108.974 64.3374C109.114 64.443 109.229 64.6541 109.417 64.7755C109.417 64.7755 109.883 65.215 110.261 65.2929C110.996 65.4444 111.84 64.765 111.84 64.765C111.84 64.765 111.996 64.5644 112.1 64.0734C112.204 63.5825 111.761 62.6481 111.251 61.4181C110.354 60.1776 108.52 55.7961 107.692 54.0329C106.077 50.5911 106.191 49.4825 101.882 49.0549C91.2419 48.0044 93.7535 52.6182 89.809 58.6889C89.043 58.1769 85.4008 53.1302 84.4629 51.9161C82.3734 49.208 80.7634 47.7774 76.1468 48.0044C71.7021 48.2261 70.6704 50.0474 69.128 53.1989C68.3829 54.7245 65.861 60.1301 65.1836 60.9958Z"
          fill="#7752A0"
        />
      </g>
      <defs>
        <filter
          id="filter0_d"
          x="0.0500488"
          y="-27.1285"
          width="176.829"
          height="176.829"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.835294 0 0 0 0 0.929412 0 0 0 0 0.929412 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}
